import { create } from '@thoughtspot/logger';
import _ from 'lodash';
const logger = create('RenderEvents');
const validateInitStartEventPayload = () => {
    return {
        isValid: true,
    };
};
const getInitStartEventProcessor = (props) => {
    return {
        validateEventPayload: validateInitStartEventPayload,
        executeEvent: () => {
            props.onInitStart();
            return Promise.resolve();
        },
    };
};
const validateRenderCompleteEventPayload = (eventData) => {
    return {
        isValid: true,
    };
};
const getRenderCompleteEventProcessor = (props) => {
    return {
        validateEventPayload: validateRenderCompleteEventPayload,
        executeEvent: (eventData) => {
            props.setIsRenderComplete(true);
            return Promise.resolve();
        },
    };
};
const validateRenderStartEventPayload = (eventData) => {
    return {
        isValid: true,
    };
};
const getRenderStartEventProcessor = (props) => {
    return {
        validateEventPayload: validateRenderStartEventPayload,
        executeEvent: (eventData) => {
            props.setRenderInProgress();
            props.setCustomChartLoadingInProgressMessage(eventData?.payload?.loadingMessage ?? null);
            return Promise.resolve();
        },
    };
};
const validateRenderErrorEventPayload = (event) => {
    if (!_.isString(event?.data?.payload.error)) {
        logger.warn('Empty/Null errors received to show.', event.data);
    }
    return {
        isValid: true,
    };
};
const getRenderErrorEventProcessor = (props) => {
    return {
        validateEventPayload: validateRenderErrorEventPayload,
        executeEvent: (eventData) => {
            props.setRenderErrorMessage(eventData.payload.error);
            return Promise.resolve();
        },
    };
};
const testHooks = {
    validateRenderCompleteEventPayload,
    validateRenderErrorEventPayload,
    validateRenderStartEventPayload,
};
export { testHooks, getRenderCompleteEventProcessor, getRenderStartEventProcessor, getRenderErrorEventProcessor, getInitStartEventProcessor, };
//# sourceMappingURL=index.js.map